"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clearComponentIds = clearComponentIds;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRedux = require("react-redux");

var _reducer = require("./reducer");

var _defaultGetInitState = _interopRequireDefault(require("./utils/defaultGetInitState"));

var _initComponent = _interopRequireDefault(require("./actions/initComponent"));

var _initMode = require("./initMode");

var _initSelfMode = require("./initSelfMode");

var _createPrepareKey = _interopRequireDefault(require("./utils/createPrepareKey"));

var _optionalParamCurried = _interopRequireDefault(require("./utils/optionalParamCurried"));

var _excluded = ["__componentInitState", "__initComponent", "__modeInitSelf"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

var componentIds = [];
var INIT_ACTION_PROP_PREPARED = 'prepared';
var INIT_ACTION_PROP_CLIENTONLY = 'clientOnly';
/**
 * Attaches an initialization action to a component.
 * @param {Array<string>} [initProps] An array of names of props that are relevant for
 * initialization. Only these props will be available in the initAction function. A component
 * is required to have these props during mount and when dispatching the prepareComponent action.
 * By default, if these props change value on the client, the component will "re-initialize".
 * See the "options" parameters.
 * @param {function} initAction The initialization action. It receives the following arguments:
 *  - `props` An object containing the values for each of the initProps.
 *  - `dispatch` The redux dispatch function
 *  - `getState` The redux getState function
 * This function MUST return a Promise that resolves once initialization has completed.
 * @param {object} options Additional optional options
 * @param {boolean} [options.reinitialize=true] If true, will call `initAction` again if any of the
 * props defined in `initProps` change after mount. This change is checked using
 * strict equality (===)
 * @param {boolean} [options.allowLazy=false] If `true`, no error will be thrown when the component
 * is mounted without being prepared using `prepareComponent()` first. Instead, the `initAction`
 * will be performed on `componentDidMount` on the client, as if it wasn't mounted on first render.
 * This can be used to do non-critical initialization, like loading data for components that
 * display below the fold.
 * @param {string} [options.initSelf="ASYNC"] A string that indicates the behavior for
 * initialization on the client (`initMode == MODE_INIT_SELF`). Possible values:
 * - "ASYNC" the component will render immediately, even if `initAction` is still pending.
 *   It is recommended to use this option and render a loading indicator or placeholder content
 *   until `initAction` is resolved. This will give the user immediate feedback that something is
 *   being loaded. While the `initAction` is pending, an `isInitializing` prop will be
 *   passed to the component.
 * - "BLOCKING" this will cause this higher-order component not tot mount the target component
 *   until the first initialization has completed. The component will remain mounted during
 *   further re-initialization.
 * - "UNMOUNT" same as "BLOCKING" but it will also unmount the component during re-initialization.
 * - "NEVER" will only initialize on the server (initMode == MODE_PREPARE). Initialization will
 *   be skipped on the client.
 * @param {function} [options.onError] Error handler for errors that occur while executing
 * initAction. If given, errors will be swallowed.
 * @param {function} [options.getPrepareKey] A function that generates a "prepare key" that will be
 * used to uniquely identify a component and its props. It has the following signature:
 * `({string} componentId, {Array} propsArray) => {string}`
 * This defaults to a function that concatenates the `componentId` and the stringified `propsArray`.
 * In most cases, this will ensure that a component instance on the server is matched to the
 * corresponding instance on the client. However, if the props are somehow always different between
 * server and client, you may use this function to generate a key that omits that difference.
 * @param {function} [options.getInitState] A function that takes the Redux state and returns
 * the init state of the reducer from this module. By default, it is assumed that the state is
 * under the "init" property. If the reducer is included elsewhere, this function can be set
 * to retrieve the state.
 * @returns {function(*)}
 */

var _default = function _default(p1, p2, p3) {
  var initActionClient = null;
  var initProps = [];
  var initAction = p1;
  var initActionObjectParam = false;
  var options = p2 || {};

  if (_typeof(p1) === 'object' && typeof p1[INIT_ACTION_PROP_PREPARED] === 'undefined' && typeof p1[INIT_ACTION_PROP_CLIENTONLY] === 'undefined') {
    initProps = p1;
    initAction = p2;
    options = p3 || {};
  }

  if (_typeof(initAction) === 'object') {
    if (typeof initAction[INIT_ACTION_PROP_CLIENTONLY] !== 'function' && typeof initAction[INIT_ACTION_PROP_PREPARED] !== 'function') {
      throw new Error("Invalid object passed as initAction to withInitAction. Must have a property \"".concat(INIT_ACTION_PROP_CLIENTONLY, "\" or  \"").concat(INIT_ACTION_PROP_PREPARED, "\""));
    }

    initActionObjectParam = true;
    var initActionPrepared = initAction[INIT_ACTION_PROP_PREPARED] || null;
    initActionClient = initAction[INIT_ACTION_PROP_CLIENTONLY] || null;
    initAction = initActionPrepared;
  } else if (typeof initAction !== 'function') {
    throw new Error("Invalid initAction param with type '".concat(_typeof(initAction), "' passed to withInitAction. Expected either a function or an object { [").concat(INIT_ACTION_PROP_CLIENTONLY, "]: function, [").concat(INIT_ACTION_PROP_PREPARED, "]: function }"));
  }

  var _options = options,
      _options$reinitialize = _options.reinitialize,
      reinitialize = _options$reinitialize === void 0 ? true : _options$reinitialize,
      onError = _options.onError,
      _options$getInitState = _options.getInitState,
      getInitState = _options$getInitState === void 0 ? _defaultGetInitState.default : _options$getInitState,
      _options$getPrepareKe = _options.getPrepareKey,
      getPrepareKey = _options$getPrepareKe === void 0 ? _createPrepareKey.default : _options$getPrepareKe,
      _options$initSelf = _options.initSelf,
      initSelf = _options$initSelf === void 0 ? _initSelfMode.INIT_SELF_ASYNC : _options$initSelf,
      _options$allowLazy = _options.allowLazy,
      allowLazy = _options$allowLazy === void 0 ? false : _options$allowLazy;
  return (0, _optionalParamCurried.default)('string', function (customComponentId, WrappedComponent) {
    var componentId = customComponentId || WrappedComponent.displayName || WrappedComponent.name;

    if (!componentId) {
      throw new Error('withInitAction() HoC requires the wrapped component to have a displayName');
    } // only warn for unique displayName when we do not have a custom getPrepareKey function


    if (getPrepareKey === _createPrepareKey.default && componentIds.includes(componentId)) {
      console.warn("Each Component passed to withInitAction() should have a unique id. Found duplicate name \"".concat(componentId, "\n Consider passing a custom id, see: https://mediamonks.github.io/react-redux-component-init/api.html#withInitActionCustom\""));
    }

    componentIds.push(componentId);
    var initConfig = {
      componentId: componentId,
      initProps: initProps,
      initAction: initAction,
      initActionClient: initActionClient,
      initActionObjectParam: initActionObjectParam,
      options: {
        reinitialize: reinitialize,
        onError: onError,
        getInitState: getInitState,
        initSelf: initSelf,
        allowLazy: allowLazy,
        getPrepareKey: getPrepareKey
      }
    };

    var WithInit = /*#__PURE__*/function (_Component) {
      _inherits(WithInit, _Component);

      var _super = _createSuper(WithInit);

      function WithInit(props) {
        var _this;

        _classCallCheck(this, WithInit);

        _this = _super.call(this, props);

        _defineProperty(_assertThisInitialized(_this), "handleInitError", function (e) {
          if (onError) {
            onError(e);
          } else {
            throw e;
          }
        });

        var __modeInitSelf = props.__modeInitSelf,
            _props$__componentIni = props.__componentInitState,
            isPrepared = _props$__componentIni.isPrepared,
            initValues = _props$__componentIni.initValues,
            prepareKey = _props$__componentIni.prepareKey;
        _this.state = {
          initializedOnce: !__modeInitSelf && isPrepared && !initActionClient
        };

        _this.props.__initComponent(initValues, prepareKey, {
          caller: 'constructor'
        }).catch(_this.handleInitError);

        return _this;
      }

      _createClass(WithInit, [{
        key: "componentDidMount",
        value: function componentDidMount() {
          var _this$props$__compone = this.props.__componentInitState,
              initValues = _this$props$__compone.initValues,
              prepareKey = _this$props$__compone.prepareKey;

          this.props.__initComponent(initValues, prepareKey, {
            caller: 'didMount'
          }).catch(this.handleInitError);
        }
      }, {
        key: "componentDidUpdate",
        value: function componentDidUpdate(prevProps) {
          if (initProps.length && reinitialize) {
            var initValues = prevProps.__componentInitState.initValues,
                __initComponent = prevProps.__initComponent;
            var _this$props$__compone2 = this.props.__componentInitState,
                newInitValues = _this$props$__compone2.initValues,
                prepareKey = _this$props$__compone2.prepareKey;

            if (initValues !== newInitValues) {
              __initComponent(newInitValues, prepareKey, {
                caller: 'didUpdate'
              }).catch(this.handleInitError);
            }
          }
        }
      }, {
        key: "render",
        value: function render() {
          // eslint-disable-next-line no-unused-vars
          var _this$props = this.props,
              __componentInitState = _this$props.__componentInitState,
              __initComponent = _this$props.__initComponent,
              __modeInitSelf = _this$props.__modeInitSelf,
              props = _objectWithoutProperties(_this$props, _excluded);

          var selfInitState = __componentInitState.selfInitState,
              isPrepared = __componentInitState.isPrepared;
          var isInitializing = !!(__modeInitSelf ? selfInitState === false || typeof selfInitState === 'undefined' && !this.state.initializedOnce : initAction && allowLazy && !isPrepared || initActionClient);
          var cloak = isInitializing && (initSelf === _initSelfMode.INIT_SELF_UNMOUNT || initSelf === _initSelfMode.INIT_SELF_BLOCKING && !this.state.initializedOnce);
          return cloak ? null : /*#__PURE__*/_react.default.createElement(WrappedComponent, _extends({
            isInitializing: isInitializing
          }, props));
        }
      }], [{
        key: "getDerivedStateFromProps",
        value: function getDerivedStateFromProps(newProps) {
          var selfInitState = newProps.__componentInitState.selfInitState;

          if (selfInitState) {
            return {
              initializedOnce: true
            };
          }

          return null;
        }
      }]);

      return WithInit;
    }(_react.Component);

    _defineProperty(WithInit, "propTypes", {
      __initComponent: _propTypes.default.func.isRequired,
      __modeInitSelf: _propTypes.default.bool.isRequired,
      __componentInitState: _propTypes.default.shape({
        initValues: _propTypes.default.arrayOf(_propTypes.default.any).isRequired,
        prepareKey: _propTypes.default.string.isRequired,
        selfInitState: _propTypes.default.bool,
        isPrepared: _propTypes.default.bool.isRequired
      }).isRequired
    });

    _defineProperty(WithInit, "displayName", "withInitAction(".concat(componentId, ")"));

    _defineProperty(WithInit, "WrappedComponent", WrappedComponent);

    var ConnectedWithInit = (0, _reactRedux.connect)(function () {
      var componentInitStateSelector = (0, _reducer.createComponentInitStateSelector)(initConfig);
      return function (state, ownProps) {
        var initState = getInitState(state);

        var __componentInitState = componentInitStateSelector(initState, ownProps);

        return {
          __componentInitState: __componentInitState,
          __modeInitSelf: initState.mode === _initMode.MODE_INIT_SELF
        };
      };
    }, function (dispatch) {
      return {
        __initComponent: function __initComponent(initValues, prepareKey, initOptions) {
          return dispatch((0, _initComponent.default)(ConnectedWithInit, initValues, prepareKey, initOptions));
        }
      };
    })(WithInit);
    ConnectedWithInit.initConfig = initConfig;
    return ConnectedWithInit;
  });
};
/**
 * Clears the component ids array used to detect duplicate components. Used for
 * testing to clear the state in between tests.
 */


exports.default = _default;

function clearComponentIds() {
  componentIds.length = 0;
}